import React from 'react';
import PropTypes from 'prop-types';
import classNames from '@jd/jmtd-tools/es/classnames';
import Radio from '../Radio';
import FormControl from '../FormControl';
export default function RadioControl(_ref) {
  var id = _ref.id,
      children = _ref.children,
      size = _ref.size,
      disabled = _ref.disabled,
      checked = _ref.checked,
      className = _ref.className,
      onChange = _ref.onChange,
      clstag = _ref.clstag;
  return /*#__PURE__*/React.createElement(FormControl, {
    id: id,
    checked: checked,
    size: size,
    disabled: disabled,
    className: classNames('jmtd-radio-control', className),
    control: /*#__PURE__*/React.createElement(Radio, {
      clstag: clstag,
      onChange: onChange
    })
  }, children);
}
RadioControl.propTypes = {
  id: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  className: PropTypes.string,
  size: PropTypes.oneOf(['large', 'middle', 'small', 'mini']),
  disabled: PropTypes.bool,
  children: PropTypes.node,
  clstag: PropTypes.string
};
RadioControl.defaultProps = {
  id: null,
  checked: false,
  onChange: function onChange() {},
  className: '',
  disabled: false,
  size: null,
  children: null,
  clstag: null
};